var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5264 17.3404L20 10.8667L26.4766 17.3432L30.2433 13.5765L20 3.33337L9.75998 13.5734L13.5265 17.3401L13.5264 17.3404ZM3.33331 20.0001L7.10011 16.2328L10.8666 19.9993L7.09985 23.7661L3.33331 20.0001ZM13.5264 22.6603L20 29.1335L26.4765 22.6572L30.2452 26.4219L30.2433 26.4239L20 36.6668L9.75998 26.4268L9.75465 26.4215L13.5268 22.6598L13.5264 22.6603ZM29.1333 20.0017L32.9001 16.2349L36.6666 20.0014L32.9 23.7683L29.1333 20.0017Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8202 19.9981H23.8218L20 16.1759L17.175 19.0001L16.8505 19.3248L16.1812 19.9943L16.1758 19.9995L16.1812 20.0049L20 23.8244L23.8221 20.0021L23.824 20L23.8205 19.9981",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.095789687fd461c866441118fbb05ac3.svg";
export { ForwardRef as ReactComponent };